import { DateTime } from "luxon";
import { FilterDTO, IUpdateVendorScoreCardAdminDataDTO, UpdateVendorScoreCardAdminDataDTO } from "../../models/models.swagger.generated";
import { SpinnerService } from "../../spinner/spinner.service";
import { fakeHttpRequest } from "../fakeHttpRequest";
import { IAdaptorBatchService } from "./adaptor-batch-service.interface";
import { AvpCustomAdaptor } from "./avp-custom-adaptor";

export class AvpCustomAdaptorBatch extends AvpCustomAdaptor {
  constructor(service: IAdaptorBatchService, spinnerService: SpinnerService, ignoreSearch: boolean = false, fixedFilters: FilterDTO[] = []) {
    super(service, spinnerService, ignoreSearch, fixedFilters);
    this.options.batchUpdate = this.batchUpdate.bind(this);
  }
  
  private batchUpdate(args) {
    const data = JSON.parse(args.data);
    this.spinnerService.show();

    // const dataConverted: UpdateVendorScoreCardAdminDataDTO[] = [];
    // data.changed.forEach(changedRow => {
    //   var d: IUpdateVendorScoreCardAdminDataDTO = {
    //     id: changedRow.id,
    //     weightedCat: changedRow.weightedCat,
    //     weightedSub: changedRow.weightedSub,
    //     tenPointsReference: changedRow.tenPointsReference,
    //     onePointReference: changedRow.onePointReference,
    //     modifiedOn: DateTime.now(),
    //     modifiedBy: "Edit"
    //   }

    //   dataConverted.push(new UpdateVendorScoreCardAdminDataDTO(d));
    // });
    const service = this.service as IAdaptorBatchService;
    service.batchUpdate(data?.changed).subscribe({next: (response) => {
      this.spinnerService.hide();
      args.onSuccess(response, { httpRequest: new fakeHttpRequest() });
    }, error: (error) => {
      this.spinnerService.hide();
      args.onFailure('batch Update failed');
    }});
  }
}